/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';

import _t from 'i18n!nls/xdp';

const TopInstructorBadge = () => {
  return (
    <Badge>
      <Typography2 variant="inherit" color="inherit" component="p">
        {_t('Top Instructor')}
      </Typography2>
    </Badge>
  );
};

export default TopInstructorBadge;
